    <div mat-dialog-title class="d-flex justify-content-between align-items-center dialog-title">
      <h1 class="title">AXIS CAMERA MODELS</h1>
      <div style="display: block;">
      <i class="fa fa-download custom-download cam-download" (click)="downloadCsv(camdata)"></i>
      <i class="fa fa-window-close cam-close" (click)="close()"></i>
      </div>
    </div>
    <div class="table-div">
        <table class="table table-bordered table-hover cam-table">
            <thead>
              <tr>
                <th class="sticky-header">Camera Model</th>
                <th class="sticky-header">Count</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngFor="let cam of camNames;let i = index">
                    <td >{{cam}}</td>
                    <td>{{camCount[i]}}</td>
                </tr>
            </tbody>
        </table>
    </div>